import { FaInstagram, FaFacebook, FaYoutube } from 'react-icons/fa'

export default function Footer() {
  return (
    <footer className="bg-[#1B1F24] text-gray-300 py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Coluna 1 - Logo e Informações */}
          <div className="flex flex-col items-center md:items-center space-y-6">
            <img src="/logo-e-icon/logo-orig+text.png" alt="Logo UniãoFerr" className="h-20 w-auto" />
            <p className="text-sm mt-4">
              CNPJ: 60.730.735/0001-00
            </p>
            <div className="flex justify-center space-x-4 mt-3">
              <a href="https://www.instagram.com/uniaoferr.oficial/#" target="_blank" rel="noopener noreferrer" className="transition-all duration-300 hover:scale-125 hover:-translate-y-1">
                <FaInstagram className="h-6 w-6 text-gray-400 hover:text-white transition-colors duration-300" />
              </a>
              <a href="https://www.facebook.com/uniaoferr" target="_blank" rel="noopener noreferrer" className="transition-all duration-300 hover:scale-125 hover:-translate-y-1">
                <FaFacebook className="h-6 w-6 text-gray-400 hover:text-white transition-colors duration-300" />
              </a>
              <a href="https://www.youtube.com/@uniaoferr" target="_blank" rel="noopener noreferrer" className="transition-all duration-300 hover:scale-125 hover:-translate-y-1">
                <FaYoutube className="h-6 w-6 text-gray-400 hover:text-white transition-colors duration-300" />
              </a>
            </div>
          </div>

          {/* Vertical Line 1 */}
          <div className="hidden md:block absolute top-0 bottom-0" style={{
            width: '1px',
            left: 'calc(33.333% - 4px)',
            background: 'linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.2) 80%, transparent)'
          }}></div>

          {/* Coluna 2 - Links Úteis */}
          <div className="flex flex-col items-center">
            <h3 className="text-white font-medium mb-4 text-center">LINKS ÚTEIS</h3>
            <ul className="space-y-2 text-center">
              <li><a href="#hero" className="relative inline-block hover:text-white transition-all duration-300 ease-in-out after:absolute after:bottom-[-2px] after:left-0 after:h-[1px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full">Home</a></li>
              <li><a href="#services" className="relative inline-block hover:text-white transition-all duration-300 ease-in-out after:absolute after:bottom-[-2px] after:left-0 after:h-[1px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full">Serviços</a></li>
              <li><a href="#trabalhos" className="relative inline-block hover:text-white transition-all duration-300 ease-in-out after:absolute after:bottom-[-2px] after:left-0 after:h-[1px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full">Portfólio</a></li>
              <li><a href="#partners" className="relative inline-block hover:text-white transition-all duration-300 ease-in-out after:absolute after:bottom-[-2px] after:left-0 after:h-[1px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full">Parceiros</a></li>
              <li><a href="#contato" className="relative inline-block hover:text-white transition-all duration-300 ease-in-out after:absolute after:bottom-[-2px] after:left-0 after:h-[1px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full">Contato</a></li>
            </ul>
          </div>

          {/* Vertical Line 2 */}
          <div className="hidden md:block absolute top-0 bottom-0" style={{
            width: '1px',
            left: 'calc(66.666% - 4px)',
            background: 'linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.2) 80%, transparent)'
          }}></div>

          {/* Coluna 3 - Dados de Contato */}
          <div className="flex flex-col items-center">
            <h3 className="text-white font-medium mb-4 text-center">DADOS DE CONTATO</h3>
            <ul className="space-y-2 text-sm text-center">
              <li>Tv. Terceira do Jaiminho, 271</li>
              <li>Jd. Arco Rio Verde</li>
              <li>Araçoiaba da Serra/SP</li>
              <li className="pt-2">
                <a href="mailto:comercial@uniaoferr.com" className="hover:text-white">
                  comercial@uniaoferr.com
                </a>
              </li>
              <li>
                <a href="tel:+551599822-5714" className="hover:text-white">
                  (15) 99822-5714
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-700 text-center text-sm">
          <p>© 2025 UNIÃOFERR. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  )
} 